import {
  AcceptType,
  ContentType,
  getRequest,
  postRequest,
} from '../../../utils/apiUtils';

export const getFilterOptions = () => {
  return getRequest<eInvoice.FilterOptions>(
    '/p2p-admin/einvoice/documents/list',
    { get_filter_options: 1 },
  );
};

export const getEInvoiceList = (params?: { search?: string }) => {
  return getRequest<{ investors: string[] }>(
    '/p2p-admin/einvoice/list',
    params,
  );
};

export const getDocumentsByInvestor = (investorName: string, params: eInvoice.EInvoiceListFilterData) => {
  return postRequest<CapBayTabularData<eInvoice.EInvoiceDocument[]>>(
    '/p2p-admin/einvoice/documents/by-investor',
    {
      ...params,
      investor_name: investorName,
    },
  );
};

export const downloadEInvoicePdf = (id: number) => {
  return getRequest<Blob>(`/p2p-admin/einvoice/documents/${id}/download-pdf`, undefined, {
    responseType: 'blob',
    acceptType: AcceptType.PDF,
    contentType: ContentType.JSON,
  });
};

